import { getBaseHost } from "@kulee/tga-constant";

console.log("11111111111", process.env.SDP_ENV);

export const API_BASE_HOST = `${getBaseHost(process.env.SDP_ENV)}/sb`;
export const BASE_HOST = getBaseHost(process.env.SDP_ENV);

console.log("BASE_HOST", BASE_HOST);
export const ENV = process.env.SDP_ENV;



// WEBPACK FOOTER //
// ./src/config/config.js